import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const customerPhoneListSlice = createApi({
    reducerPath: "customerPhoneList",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        customerPhoneList: builder.query({
            query: (data) => ({ url: "/order-management/api/v1/phone/list", params: data, method: "GET" }),
        }),
    }),
});

export const { useCustomerPhoneListQuery } = customerPhoneListSlice;
